import { useState } from 'react'
import type { JSX } from 'react'

import { Flex, Separator } from '@buffer-mono/popcorn'

import BackupEmail, { BackupEmailBanner } from './components/BackupEmail'
import Delete from './components/DeleteAccount'
import Email, { EmailVerificationBanner } from './components/Email'
import Name from './components/Name'
import Password from './components/Password'
import Photo from './components/Photo'
import TwoFactor, { TwoFactorBanner } from './components/TwoFactor'
import { NewSettingsPageLayout } from '../shared/components/NewSettingsPageLayout'
const ProfileSettings = (): JSX.Element => {
  const [triggerAccountFetch, setTriggerAccountFetch] = useState(false)
  return (
    <NewSettingsPageLayout title="Profile">
      <Flex gap="lg" direction="column" fullWidth>
        <EmailVerificationBanner />
        <BackupEmailBanner />
        <TwoFactorBanner />
        <Photo />
        <Name />
        <Email />
        <BackupEmail triggerAccountFetch={triggerAccountFetch} />
        <Password />
      </Flex>
      <Separator />
      <TwoFactor onAddBackup={() => setTriggerAccountFetch(true)} />
      <Separator />
      <Delete />
    </NewSettingsPageLayout>
  )
}

export default ProfileSettings
